export const formatDuration = (duration) => {
    const sec = parseInt(duration.as('seconds'), 10); // convert value to number if it's string
    let minutes = Math.floor(sec  / 60); // get minutes
    let seconds = sec - (minutes * 60)//  get seconds

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
};